import * as React from 'react';
import NotificationChannel from '../models/NotificationChannel';
import NotificationChannelMgmtService from '../../shared/services/NotificationChannelMgmtService';
import Loading from '../../shared/components/loading/Loading';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  WithStyles,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField
} from '@material-ui/core';
import { withStyles, StyleRules } from '@material-ui/core/styles';
import DateHelper from 'src/modules/shared/helpers/DateHelper';
import history from '../../../history/browserHistory';
import HttpCallConfig from 'src/modules/core/models/HttpCallConfig';

const styles: StyleRules = {
  table: {
    padding: 24,
    paddingTop: 0,
  },
  tableHead: {
    '& th': {
      width: '16.67%',
    },
  },
  tableRow: {
    height: 40,
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
};

interface IState {
  notificationChannels: NotificationChannel[];
  isLoading: boolean;
  testOpen: boolean;
  payload: string;
  selected: string;
}

interface IProps extends WithStyles<typeof styles> { }

class NotificationChannelOverview extends React.Component<IProps> {
  public static SortNotificationChannels = (
    channelA: NotificationChannel,
    channelB: NotificationChannel
  ) => {
    return (
      new Date(channelB.updatedOn).getTime() -
      new Date(channelA.updatedOn).getTime()
    );
  };

  public state: IState = {
    notificationChannels: [],
    isLoading: true,
    testOpen: false,
    selected: '',
    payload: `{ 
  "description": "this is a test"
}`
  };

  public async componentDidMount() {
    this.setState({
      notificationChannels: await NotificationChannelMgmtService.GetNotificationChannels(),
      isLoading: false,
    });
  }

  public async sendTest() {
    const httpCallConfig = new HttpCallConfig();
    httpCallConfig.successMessage = 'Message sent.'
    const body: any = {
      text: this.state.payload,
      notificationId: this.state.selected
    }
    await NotificationChannelMgmtService.sendTestNotification(body, httpCallConfig);
  }

  public renderNotificationChannel = (channel: NotificationChannel) => {
    const { classes } = this.props;

    return (
      <TableRow
        hover
        tabIndex={-1}
        key={channel.id}
        className={classes.tableRow}
      >
        <TableCell padding="none">{channel.name}</TableCell>
        <TableCell padding="none">{channel.channelTypeId}</TableCell>
        <TableCell padding="none">
          {DateHelper.FormatDate(channel.updatedOn)}
        </TableCell>
        <TableCell padding="none">
          {DateHelper.FormatDate(channel.createdOn)}
        </TableCell>
        <TableCell
          padding="none"
          onClick={() => {
            history.push(
              `/organization/notificationchannels/${channel.channelTypeId.toLocaleLowerCase()}/${channel.id
              }`
            );
          }}
          className={classes.link}
        >
          Edit
        </TableCell>
        <TableCell
          padding="none"
          onClick={() => {
            this.setState({ testOpen: true, selected: channel.id })
          }}
          className={classes.link}
        >
          Test
        </TableCell>
      </TableRow>
    );
  };

  public render() {
    const { notificationChannels, isLoading } = this.state;
    const { classes } = this.props;
    const handleClose = () => this.setState({ testOpen: false })
    if (isLoading) {
      return (
        <div>
          <Loading />
        </div>
      );
    }

    return (
      <Paper>
        <div className={classes.table}>
          <Table aria-labelledby="tableTitle">
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell padding="none">Name</TableCell>
                <TableCell padding="none">Type</TableCell>
                <TableCell padding="none">Last Update</TableCell>
                <TableCell padding="none">Created</TableCell>
                <TableCell padding="none" colSpan={2}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notificationChannels
                .sort(NotificationChannelOverview.SortNotificationChannels)
                .map(this.renderNotificationChannel)}
            </TableBody>
          </Table>
          <Dialog open={this.state.testOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Send test notification</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please define a payload to send on your notification channel as a test.
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="dkhfd"
                label="JSON Payload"
                multiline={true}
                fullWidth
                value={this.state.payload}
                onChange={(e) => { this.setState({ payload: e.target.value }) }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
          </Button>
              <Button onClick={()=>{handleClose(),this.sendTest()}} color="primary">
                Send
          </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(NotificationChannelOverview);



// WEBPACK FOOTER //
// ./src/modules/organization/components/NotificationChannelOverview.tsx